//Author June Leow
//Date Mar 25th, 2024
import Buildings from './buildings';
import FloatingTab from './floating-tab';
import React, {useEffect} from 'react';

const StepSite  = (props)=>{
  const controller = new AbortController();

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state

  //API call

  //render
  return <div>
      <br/>
      <Buildings {...props}/>
      <FloatingTab {...props} save={props.save}/>
    </div>
}


export default StepSite;